// Function to set all falsy preferences to `null` due to changes in how
// the BE handles 'no preference' settings.
// Ideally we set the default onboarding and preference values to `null`
// to begin with, but not implemented currently due to time constraints.

export const normalizePayload = <T>(payload: T) => {
  const result = {...payload};

  for (const key in result) {
    if (
      result[key] === undefined ||
      result[key] === '' ||
      (Array.isArray(result[key]) && (result[key] as Array<string>).length === 0)
    ) {
      // TODO: Set empty values to null when backend supports it. Still a bit of a quick and dirty FE solution but the easiest for now
      delete result[key];
    }
  }

  return result;
};
